import { Text, View } from "@react-pdf/renderer";
import { CreateBillDto } from "../model/bill/dto/CreateBillDto";

const hashColumnStyle: any = {
  borderStyle: "solid",
  borderColor: "#000",
  borderWidth: 1,
  borderTopWidth: 0,
  width: "4%",
  display: "flex",
  justfiyContent: "center",
  alignItems: "center",
};

const tableColStyle: any = {
  borderStyle: "solid",
  borderColor: "#000",
  borderWidth: 1,
  borderLeftWidth: 0,
  borderTopWidth: 0,
};

const tableCellStyle: any = {
  textAlign: "center",
  margin: 2,
  fontSize: "6px",
};

const tableRowStyle: any = {
  flexDirection: "row",
};

type PDFRowProps = {
  index: number;
  data: CreateBillDto["billDetails"][number];
};

export const TableRow: React.FC<PDFRowProps> = ({ data, index }) => {
  return (
    <View style={tableRowStyle}>
      <View style={hashColumnStyle}>
        <Text style={tableCellStyle}>{index + 1}</Text>
      </View>

      <View style={{ ...tableColStyle, width: "7%" }}>
        <Text style={tableCellStyle}>{data.qty}</Text>
      </View>

      <View style={{ ...tableColStyle, flex: 1 }}>
        <Text style={tableCellStyle}>{data.code}</Text>
      </View>

      <View style={{ ...tableColStyle, flex: 6 }}>
        <Text style={tableCellStyle}>{data.description}</Text>
      </View>

      <View style={{ ...tableColStyle, flex: 1 }}>
        <Text style={tableCellStyle}>{data.unitPrice}</Text>
      </View>

      <View style={{ ...tableColStyle, flex: 2, paddingRight: 15 }}>
        <Text style={tableCellStyle}>{data.amount}</Text>
      </View>
    </View>
  );
};
